import { FORM_ERROR } from 'final-form';
import { t } from 'utils';
import { newPasswordRules, passwordFormFields } from './constants';

export interface IValues {
  [key: string]: string;
}

export interface IPasswordErrors {
  [key: string]: string | string[];
}

export const passwordModalValidator = (values: IValues): IPasswordErrors => {
  const errors: IPasswordErrors = {};

  for (const field in passwordFormFields) {
    const { name, label }: { name: string; label: string } = passwordFormFields[field];
    const value = values[name];

    if (!value) {
      return {
        ...errors,
        [FORM_ERROR]: t('errors.invalidField', [{ key: 'FIELD', value: t(label) }]),
        [name]: t('errors.required'),
      };
    }

    if (name === passwordFormFields.newPassword.name) {
      const newPasswordErrors = newPasswordRules.reduce<string[]>(
        (rules, rule) =>
          rule.validate(value) ? rules : [...rules, t(`errors.password.${rule.name}`)],
        []
      );

      if (newPasswordErrors.length) {
        errors[name] = newPasswordErrors;
        errors[FORM_ERROR] = t('errors.invalidNewPassword');

        return errors;
      }
    }
  }

  return errors;
};
